import styled from 'styled-components'
import { colorWithOpacity } from '../../../utilities/color'

export const CardContainer = styled.article`
    background-color: ${props => colorWithOpacity(props.theme.color.foreground, 0.933)};
    padding: 32px 48px;
    display: flex;
    flex-direction: column;
    // border-radius: 12px;
`